import { PropsWithChildren } from 'react'

import { AutoEnrollmentRepository } from '@/AutoEnrollment/domain'
import {
  IUseAutoEnrollmentController,
  useAutoEnrollmentController,
} from '@/AutoEnrollment/ui/hooks'
import { createGenericContext } from '@/Shared/ui/createGenericContext'

type Context = {
  repository: AutoEnrollmentRepository
} & IUseAutoEnrollmentController

type Props = PropsWithChildren & {
  repository: AutoEnrollmentRepository
}

const [useAutoEnrollment, StateContextProvider] = createGenericContext<Context>()

const AutoEnrollmentProvider = ({ repository, children }: Props): JSX.Element => {
  const controller = useAutoEnrollmentController(repository)
  return (
    <StateContextProvider value={{ repository, ...controller }}>
      {children}
    </StateContextProvider>
  )
}

export { AutoEnrollmentProvider, useAutoEnrollment }
